"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _functions = require("../@functions");
var _constants = require("../../../zerocode/src/@constants");
var _Icon = _interopRequireDefault(require("./Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("../@assets/sass/custom/InboxRequest.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @param {Object} props
 * @param {string=} props.title
 * @param {Error} props.error
 * @param {{
 *     [key: string]: any
 * }=} props.additionalInfo
 */
function InboxRequest(_ref) {
  var _error$config, _error$config$data, _error$response, _error$config3, _error$config4;
  var title = _ref.title,
    error = _ref.error,
    _ref$additionalInfo = _ref.additionalInfo,
    additionalInfo = _ref$additionalInfo === void 0 ? {} : _ref$additionalInfo;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  if ((_error$config = error.config) !== null && _error$config !== void 0 && (_error$config$data = _error$config.data) !== null && _error$config$data !== void 0 && _error$config$data.password) {
    var _error$config2;
    (_error$config2 = error.config) === null || _error$config2 === void 0 ? true : delete _error$config2.data.password;
  }
  var stack = {
    date: new Date().toLocaleString(),
    browser: (0, _functions.getBrowser)() || 'unknown',
    location: window.location.href,
    error: error.message,
    // @ts-ignore
    response: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data,
    config: {
      // @ts-ignore
      url: (_error$config3 = error.config) === null || _error$config3 === void 0 ? void 0 : _error$config3.url,
      // @ts-ignore
      data: (_error$config4 = error.config) === null || _error$config4 === void 0 ? void 0 : _error$config4.data
    },
    additionalInfo: additionalInfo
  };
  var jsonStringified = JSON.stringify(stack, null, 4);
  var handleCopy = function handleCopy() {
    navigator.clipboard.writeText(jsonStringified);
    setCopied(true);
    setTimeout(function () {
      return setCopied(false);
    }, 1500);
  };
  (0, _react.useEffect)(function () {
    console.error(error);
  }, [error]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "InboxRequest"
  }, title && /*#__PURE__*/_react["default"].createElement("p", null, title), /*#__PURE__*/_react["default"].createElement("p", null, "Acesse", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: _constants.inboxLink,
    target: "_blank",
    rel: "noreferrer"
  }, "Inbox"), ' ', "para gerar um ticket para que nossa equipe t\xE9cnica possa solucionar o problema. Por favor, copie a mensagem de erro abaixo e envie na solicita\xE7\xE3o:"), /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    onClick: handleCopy,
    "data-tooltip": "Copiar mensagem"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: copied ? 'faClipboardCheck' : 'faClipboard'
  })), /*#__PURE__*/_react["default"].createElement("pre", null, jsonStringified));
}
InboxRequest.propTypes = {
  title: _propTypes["default"].string,
  error: _propTypes["default"].shape({
    message: _propTypes["default"].string,
    response: _propTypes["default"].shape({
      data: _propTypes["default"].any
    }),
    config: _propTypes["default"].shape({
      url: _propTypes["default"].string,
      data: _propTypes["default"].any
    })
  }),
  additionalInfo: _propTypes["default"].object
};
var _default = InboxRequest;
exports["default"] = _default;